import React from 'react';
import { useTranslation } from 'react-i18next';
import './NotFoundPage.css';
import notFoundImage from './page_404.png';

export interface NotFoundPageProps {
  /** Custom title text */
  title?: string;
  /** Custom description text */
  description?: string;
  /** Custom button text */
  buttonText?: string;
  /** Callback when the button is clicked */
  onButtonClick?: () => void;
  /** Custom image URL (optional, uses default if not provided) */
  imageUrl?: string;
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
  imageUrl,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else if (typeof window !== 'undefined') {
      window.location.href = '/';
    }
  };

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        {/* Illustration */}
        <div className="not-found-image-wrapper">
          <img
            src={imageUrl || notFoundImage}
            alt={t('notFound.imageAlt', 'Page not found illustration')}
            className="not-found-image"
          />
        </div>

        {/* Content */}
        <div className="not-found-content">
          <h1 className="not-found-title">
            {title || t('notFound.title', '404 - Page Not Found')}
          </h1>
          <p className="not-found-description">
            {description ||
              t(
                'notFound.description',
                'Sorry, the page you are looking for might have been removed, had its name changed, or is temporarily unavailable.'
              )}
          </p>
          <button
            type="button"
            className="not-found-button"
            onClick={handleClick}
          >
            {buttonText || t('notFound.button', 'Go to Homepage')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
